import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import RouteNameConstants from "../constants/route-name-constants";
import { AuthService } from "./auth.service";

@Injectable()
export class AdminAuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate() {
    return this.authService.isAdminGroupProfileAsync().then((x) => {
      if (!x) {
        this.router.navigate([RouteNameConstants.NO_ACCESS]);
      }
    });
  }
}
